// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CjP8","newExpiryDate":"styles_newExpiryDate__141X3","footer":"styles_footer__391M-"};